import { render, staticRenderFns } from "./ManufacturerRetailerByAgingCredit.vue?vue&type=template&id=3588027d&"
import script from "./ManufacturerRetailerByAgingCredit.vue?vue&type=script&lang=js&"
export * from "./ManufacturerRetailerByAgingCredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports